<div class="container-card-acceso" *ngIf="mostrarUltimosDocs">
  <mat-card>
    <h2 class="header-card-acceso">{{ "ACCESOS_DIRECTOS" | translate |uppercase}}</h2>

    <div class="slick-wrapper arrows-config top-carousel">
      <!-- Primer elemento fijo -->
      <div class="slide fixed-slide" style="position: absolute; z-index: 9; background: white" *ngIf="arrowsVisible && false">
        <div class="carousel-element"  mat-raised-button (click)="onSeguimientoEntregaClick()">
          <span class="new-label">¡{{"Nuevo" | translate}}!</span>
          <div class="container-icono-grupo">
              <img
              src="assets/images/AccesosDirectos/iconoWhatsapp.svg"
              viewBox="0 0 683 432"
              alt=""
              class="icono-svg"
            />
          </div>
          <p class="carousel-element-child documento">
            {{ "SEGUIMIENTO_DE_ENTREGAS" | translate }}
          </p>
        </div>
      </div>
      <ngx-slick-carousel
        class="carousel"
        #slickModal="slick-carousel"
        [config]="slideConfig"
        (afterChange)="onAfterCarouselChange($event)"
      >
        <!-- Se agrega elemento vacio para dejar fijo el primer elemento del carrusel. Boton de "Seguimiento de entrega" -->
        <div ngxSlickItem class="slide" *ngIf="false">
          <div class="carousel-element" *ngIf="arrowsVisible">
          </div>
          <div class="carousel-element"  mat-raised-button (click)="onSeguimientoEntregaClick()" *ngIf="!arrowsVisible">
            <span class="new-label">¡{{"Nuevo" | translate}}!</span>
            <div class="container-icono-grupo">
                <img
                src="assets/images/AccesosDirectos/iconoWhatsapp.svg"
                viewBox="0 0 683 432"
                alt=""
                class="icono-svg"
              />
            </div>
            <p class="carousel-element-child documento">
              {{ "SEGUIMIENTO_DE_ENTREGAS" | translate }}
            </p>
          </div>
        </div>

        <div ngxSlickItem *ngFor="let doc of ultimosDocs" class="slide">
          <div class="carousel-element" (click)="onGrupoClick($event, doc)">
            <div class="container-icono-grupo">
              <img
                src="{{ 'assets/images/AccesosDirectos/'.concat(doc.icono) }}"
                viewBox="0 0 683 432"
                alt=""
                class="icono-svg"
              />
            </div>

            <p class="carousel-element-child documento">
              {{ doc.resourceKeyGrupo | translate }}
              {{ doc.sentido | translate }}
            </p>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </mat-card>
</div>

<div class="container-card-acceso" *ngIf="mostrarProveedores">
  <mat-card>
    <h2 class="header-card-acceso">
      {{ "PORTAL_DE_PROVEEDORES" | translate }}
    </h2>
    <h3 class="sub-header-card-acceso">
      {{ "SUB-HEADER-PORTAL-PROVEEDORES" | translate }}
    </h3>

    <div class="slick-wrapper arrows-config proveedores-slick">
      <ngx-slick-carousel
        class="carousel"
        #slickModal="slick-carousel"
        [config]="proveedoresConfig"
      >
        <div
          ngxSlickItem
          *ngFor="let proveedor of proveedores; let i = index"
          class="slide"
        >
          <app-logo-pp
            [proveedor]="proveedores[i]"
            (click)="onProveedorClick($event, proveedor)"
          ></app-logo-pp>
        </div>
      </ngx-slick-carousel>
    </div>
  </mat-card>
</div>
